import { createContext, FC, useContext } from 'react'

const MediaReloadContext = createContext(0)

/**
 * How many times someone outside the stage asked its player to load its file
 * again. Nobody does, unless presenter mode plays the media in the
 * presentation window and the console's remote asks it to; a count, so each
 * request is a change a player can see.
 */
export const ProvideMediaReloadRequests: FC<{ requests: number }> = ({
	requests,
	children,
}) => (
	<MediaReloadContext.Provider value={requests}>
		{children}
	</MediaReloadContext.Provider>
)

export const useMediaReloadRequests = (): number =>
	useContext(MediaReloadContext)
